import * as R from 'ramda';

let NODE_ENV = process.env.NODE_ENV; // 可选值为production、beta、dev

const HOSTS = {
  // main: '/admin',
  main: '/api',
  root: '',
  common: '/common'
};

export default (apiType = 'main') => {
  const apiConfig = HOSTS[apiType];
  if (R.is(Object, apiConfig)) {
    return apiConfig[NODE_ENV];
  }
  return apiConfig;
};



// WEBPACK FOOTER //
// ./src/config/hosts.js